// extracted by mini-css-extract-plugin
module.exports = {"container":"WelcomeDialog-module--container--31H5O"};